export default __webpack_public_path__ + "static/media/11.ffa8336e.jpg";